import React from "react";

// Reusable text logo matching the original site (two stacked serif words)
const Logo = ({ className = "", onClick }) => {
  return (
    <div className={`logo-mark ${className}`} onClick={onClick}>
      <span className="l1">Francesca</span>
      <span className="l2">Spinazzola</span>
    </div>
  );
};

export default Logo;
